<template>
  <div>
    <header
      class="header white-bg"
      v-if="
        !(
          $route.name == 'Blank' ||
          $route.name == 'ManageDealUpdateCreate' ||
          $route.name == 'ManageDealUpdateById' ||
          $route.name == 'copydeal'
        )
      "
      :class="headerClass"
    >
      <!-- <router-link :to="{ name: 'Home' }">
        <img src="../../assets/images/Voyado_logo.svg" alt class="logo" />
      </router-link> -->
      <div class="title-nav">{{ $store.state.title }}</div>

      <div class="top-nav">
        <div class="nav top-menu">
          <div class="flex user-info">
            <model-select
              v-if="
                $store.state.cognitoInfo.companylist &&
                $store.state.cognitoInfo.companylist.length > 1
              "
              v-model="$store.state.cognitoInfo.companyid"
              :options="$store.state.cognitoInfo.companylist"
              placeholder="Select Company"
              id="ddlCompany"
              class="form-control ddlcompany-header mr-1"
              @update:modelValue="onCompanyChange"
              :selected="$store.state.cognitoInfo.companyid"
              :searchable="true"
            ></model-select>

            <span
              v-if="
                $store.state.cognitoInfo.companylist &&
                $store.state.cognitoInfo.companylist.length == 1
              "
              class="current-company"
              >{{ $store.state.cognitoInfo.companyname }}</span
            >
            <model-select
              v-model="selectedLanguage"
              :options="languages"
              placeholder="Select Language"
              id="ddlLanguage"
              class="form-control ddlLanguage-header mr-1"
              style="width: auto"
              @update:modelValue="onLanguageChange"
              option-label="text"
              option-value="value"
              :searchable="true"
            ></model-select>
            <span class="username-text"
              >{{ lmodel.welcome1 }},
              {{ $store.state.cognitoInfo.displayname }}</span
            >
            <!-- Notification Badge -->
            <span
              class="notification-badge"
              @click="
                $router.push({
                  name: 'errorlogbycompany',
                })
              "
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
            >
              <i
                v-badge="this.notifiedErrorCount"
                class="pi pi-bell"
                style="font-size: 1rem"
            /></span>

            <span @click="setupDropdownToggle" v-clickOutside="dropDownOutside">
              <button class="dropdownBtn" id="dropdownBtn">
                <i class="user-icon-new"></i>
              </button>
              <div
                class="dropdown-content"
                id="dropdownMenu"
                v-if="dropdownShow"
              >
                <template v-for="(item, index) in items" :key="index">
                  <div v-if="item.separator" class="dropDownSeparator"></div>
                  <a
                    v-else
                    @click.prevent="item.command ? item.command() : null"
                    class="dropdownItems"
                    @mouseenter="hoveredItem = index"
                    @mouseleave="hoveredItem = null"
                  >
                    <i
                      v-if="item.icon"
                      :class="
                        hoveredItem === index &&
                        item.label === 'Logout' &&
                        item.hoverIcon
                          ? item.hoverIcon
                          : item.icon
                      "
                      style="margin-right: 8px"
                    ></i>
                    {{ item.label }}
                  </a>
                </template>
              </div>
            </span>
          </div>
        </div>
      </div>
    </header>

    <aside v-clickOutside="handleClickOutside">
      <div
        id="sidebar"
        :class="{ pinned: pinMenu, unpinned: !pinMenu }"
        style="overflow-y: auto"
      >
        <div class="menu">
          <div class="box">
            <router-link
              v-if="$store.state.cognitoInfo.role != 'Accessadmin'"
              :to="{ name: 'VoyadoDashboard' }"
            >
              <img src="../../assets/images/Voyado_logo.svg" alt class="logo" />
            </router-link>
            <router-link v-else :to="{ name: 'UserList' }">
              <img src="../../assets/images/Voyado_logo.svg" alt class="logo" />
            </router-link>
          </div>
          <div
            class="box"
            v-if="$store.state.cognitoInfo.role !== 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'VoyadoDashboard' }"
              id="VoyadoDashboard"
              :class="{
                'menu-item selected': OverviewTabArray.includes(CurrPath),
                'menu-item': !OverviewTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' overview-active selected':
                    OverviewTabArray.includes(CurrPath),
                  ' overview-icon': !OverviewTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.overview1 }}</span>
          </div>
          <!-- <div
            class="box"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'Home' }"
              id="Home"
              :class="{
                'menu-item selected': HomeTabArray.includes(CurrPath),
                'menu-item': !HomeTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'dashboard-active selected': HomeTabArray.includes(CurrPath),
                  'dashboard-icon': !HomeTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuDashboard }}</span>
          </div> -->

          <div
            v-show="false"
            class="box"
            @click="toggleSidebar('deal')"
            v-if="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="deal-wizard"
              :class="{
                'menu-item selected': DealTabArray.includes(CurrPath),
                'menu-item': !DealTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'plus-active selected': DealTabArray.includes(CurrPath),
                  plus: !DealTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuDealWizard }}</span>
          </div>

          <div
            class="box"
            @click="toggleSidebar('config')"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="configuration"
              :class="{
                'menu-item selected': ConfigTabArray.includes(CurrPath),
                'menu-item': !ConfigTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'cogs-active selected': ConfigTabArray.includes(CurrPath),
                  'cogs-icon': !ConfigTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuConfiguration }}</span>
          </div>
          <div
            class="box"
            @click="toggleSidebar('accelerator')"
            v-if="shouldShowAcceleratorMenu"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="acc"
              :class="{
                'menu-item selected': AccTabArray.includes(CurrPath),
                'menu-item': !AccTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'acc-active selected': AccTabArray.includes(CurrPath),
                  'acc-icon': !AccTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.accelerator }}</span>
          </div>
          <!-- <div
          v-if="$store.state.cognitoInfo.role == 'Superadmin'"
            class="box"
            @click="isExpandHide()"
          >
            <router-link
            
              style="text-decoration: none"
               :to="{ name: 'acceleratorsite' }"
              id="acceleratorsite"
               :class="{
                'menu-item selected': AcceleratorSitesTabArray.includes(CurrPath),
                'menu-item': !AcceleratorSitesTabArray.includes(CurrPath),
              }"
          
            >
              <i
                :class="{
                  'pen-active-icon selected': AcceleratorSitesTabArray.includes(CurrPath),
                  'pen-icon': !AcceleratorSitesTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuAccelerator }}</span>
          </div> -->
          <div
            class="box"
            @click="toggleSidebar('newdeal')"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="newdeal"
              :class="{
                'menu-item selected': ManageDealTabArray.includes(CurrPath),
                'menu-item': !ManageDealTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'pen-active-icon selected':
                    ManageDealTabArray.includes(CurrPath),
                  'pen-icon': !ManageDealTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span
              class="menu-text"
              style="
                display: inline-block;
                max-width: 55px;
                word-wrap: break-word;
              "
              >{{ lmodel.menuManageDeals }}</span
            >
          </div>

          <!-- <div
            class="box"
            @click="isExpandHide()"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'ManageDealListNew' }"
              id="manage-deals"
              :class="{
                'menu-item selected': ManageDealTabArray.includes(CurrPath),
                'menu-item': !ManageDealTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'pen-active-icon selected':
                    ManageDealTabArray.includes(CurrPath),
                  'pen-icon': !ManageDealTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span
              class="menu-text"
              style="
                display: inline-block;
                max-width: 55px;
                word-wrap: break-word;
              "
              >{{ lmodel?.menuManageDeals }}</span
            >
          </div> -->

          <div
            class="box"
            @click="toggleSidebar('insight')"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="insight-reports"
              :class="{
                'menu-item selected': ReportTabArray.includes(CurrPath),
                'menu-item': !ReportTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'report-active selected': ReportTabArray.includes(CurrPath),
                  'report-icon': !ReportTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuInsightReports }}</span>
          </div>

          <div
            class="box"
            v-if="$store.state.cognitoInfo.role != 'User'"
            @click="isExpandHide()"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'UserList' }"
              id="user-list"
              :class="{
                'menu-item selected': UserTabArray.includes(CurrPath),
                'menu-item': !UserTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'user-active selected': UserTabArray.includes(CurrPath),
                  'user-icon': !UserTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuUsers }}</span>
          </div>

          <!-- <div
            class="box"
            @click="isExpandHide()"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'Translation' }"
              id="administration"
              :class="{
                'menu-item selected': AudienceTabArray.includes(CurrPath),
                'menu-item': !AudienceTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'admin-active selected': AudienceTabArray.includes(CurrPath),
                  'admin-icon': !AudienceTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuTranslation }}</span>
          </div> -->
          <div
            class="box"
            v-if="
              $store.state.cognitoInfo.role != 'User' &&
              $store.state.cognitoInfo.role != 'Singletenantadmin' &&
              $store.state.cognitoInfo.role != 'Accessadmin'
            "
            @click="toggleSidebar('operation')"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="operation-wizard"
              :class="{
                'menu-item selected': ContactTabArray.includes(CurrPath),
                'menu-item': !ContactTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'operate-dash-active selected':
                    ContactTabArray.includes(CurrPath),
                  'operate-dash-icon': !ContactTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuOprationWizard }}</span>
          </div>

          <!-- <div
            class="box"
            v-if="$store.state.cognitoInfo.role !== 'Accessadmin'"
            @click="isExpandHide()"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'ModifyDeal' }"
              id="deal-list"
              :class="{
                'menu-item selected': DealListTabArray.includes(CurrPath),
                'menu-item': !DealListTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'list-active selected': DealListTabArray.includes(CurrPath),
                  'list-icon': !DealListTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.dealList1 }}</span>
          </div> -->
          <!-- 
          <div
            class="box"
            v-if="
              $store.state.cognitoInfo.role == 'Superadmin' ||
              $store.state.cognitoInfo.role == 'Systemadmin'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'acceleratordashboard' }"
              id="acceleratordashboard"
              :class="{
                'menu-item selected': AcceleratorTabArray.includes(CurrPath),
                'menu-item': !AcceleratorTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' overview-active selected':
                    AcceleratorTabArray.includes(CurrPath),
                  ' overview-icon': !AcceleratorTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.menuAccelerator }}</span>
          </div> -->
          <div
            class="box"
            @click="toggleSidebar('acceleratordashboard')"
            v-if="
              $store.state.cognitoInfo.role != 'User' &&
              $store.state.cognitoInfo.role != 'Singletenantadmin' &&
              $store.state.cognitoInfo.role != 'Accessadmin' &&
              (this.$store.state.leads.isEcom == true ||
                this.$store.state.leads.isElevate == true) &&
              this.$store.state.cognitoInfo.companyid != '_all'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: '' }"
              id="acceleratordashboard"
              :class="{
                'menu-item selected': AcceleratorTabArray.includes(CurrPath),
                'menu-item': !AcceleratorTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' overview-active selected':
                    AcceleratorTabArray.includes(CurrPath),
                  ' overview-icon': !AcceleratorTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.menuAccelerator }}</span>
          </div>
          <div
            class="box"
            v-show="$store.state.cognitoInfo.role == 'Superadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'OnsiteDashboard' }"
              id="OnsiteDashboard"
              :class="{
                'menu-item selected': HomeTabArray.includes(CurrPath),
                'menu-item': !HomeTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'dashboard-active selected': HomeTabArray.includes(CurrPath),
                  'dashboard-icon': !HomeTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuDashboard }}</span>
          </div>
          <!-- <div
            class="box"
            v-if="
              $store.state.cognitoInfo.role == 'Superadmin' ||
              $store.state.cognitoInfo.role == 'Systemadmin'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'VoyadoDashboard' }"
              id="VoyadoDashboard"
              :class="{
                'menu-item selected': OverviewTabArray.includes(CurrPath),
                'menu-item': !OverviewTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' overview-active selected':
                    OverviewTabArray.includes(CurrPath),
                  ' overview-icon': !OverviewTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.overview1 }}</span>
          </div> -->
          <div
            class="box"
            v-if="
              $store.state.cognitoInfo.role == 'Superadmin' ||
              $store.state.cognitoInfo.role == 'Systemadmin'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'contentgenerator' }"
              id="contentgenerator"
              :class="{
                'menu-item selected':
                  ContentGeneratorTabArray.includes(CurrPath),
                'menu-item': !ContentGeneratorTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' imageai-icon-select selected':
                    ContentGeneratorTabArray.includes(CurrPath),
                  ' imageai-icon': !ContentGeneratorTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel.contentGenerator1 }}</span>
          </div>
          <div
            v-show="true"
            class="box"
            v-if="
              $store.state.cognitoInfo.role == 'Superadmin' ||
              $store.state.cognitoInfo.role == 'Systemadmin'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'aicontent' }"
              id="aicontent"
              :class="{
                'menu-item selected': aiContentTabArray.includes(CurrPath),
                'menu-item': !aiContentTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' imageai-icon-select selected':
                    aiContentTabArray.includes(CurrPath),
                  ' imageai-icon': !aiContentTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">Ai Image</span>
          </div>
          <div
            class="box"
            v-if="
              $store.state.cognitoInfo.role == 'Superadmin' ||
              $store.state.cognitoInfo.role == 'Systemadmin'
            "
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'aivideocontent' }"
              id="aivideocontent"
              :class="{
                'menu-item selected': aiVideoContentTabArray.includes(CurrPath),
                'menu-item': !aiVideoContentTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' imageai-icon-select selected':
                    aiVideoContentTabArray.includes(CurrPath),
                  ' imageai-icon': !aiVideoContentTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">Ai Video</span>
          </div>
          <div
            class="box"
            @click="isExpandHide()"
            v-show="$store.state.cognitoInfo.role != 'Accessadmin'"
          >
            <router-link
              style="text-decoration: none"
              :to="{ name: 'Translation' }"
              id="administration"
              :class="{
                'menu-item selected': AudienceTabArray.includes(CurrPath),
                'menu-item': !AudienceTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  'admin-active selected': AudienceTabArray.includes(CurrPath),
                  'admin-icon': !AudienceTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">{{ lmodel?.menuTranslation }}</span>
          </div>
          <!-- <div class="box" v-if="$store.state.cognitoInfo.role == 'Superadmin'">
            <router-link
              style="text-decoration: none"
              :to="{ name: 'leadads' }"
              id="leadads"
              :class="{
                'menu-item selected':
                  LeadAdsTabArray.includes(CurrPath),
                'menu-item': !LeadAdsTabArray.includes(CurrPath),
              }"
            >
              <i
                :class="{
                  ' leadads-active selected':
                    LeadAdsTabArray.includes(CurrPath),
                  ' leadads-icon': !LeadAdsTabArray.includes(CurrPath),
                }"
              ></i>
            </router-link>
            <span class="menu-text">LeadAds</span>
          </div> -->
          <!-- <PrimeToast /> -->
        </div>
      </div>

      <div
        :class="{
          'expanded-content': true,
          expanded: isExpanded,
        }"
        style="overflow-y: auto"
      >
        <div>
          <div v-show="visibleDealMenu">
            <div class="menu-head">{{ lmodel?.menuDealWizard }}</div>
            <!-- <router-link
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Admin' ||
                $store.state.cognitoInfo.role == 'Partner' ||
                $store.state.cognitoInfo.role == 'Admin'
              "
              :to="{ name: 'NewDealCreate' }"
              id="NewDealCreate"
              :class="{
                'menu-item1 selected': CurrPath == 'NewDealCreate',
                'menu-item1': CurrPath != 'NewDealCreate',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()">
                <i class="plus"></i>{{ lmodel?.menuNewWizardPage }}</span
              >
            </router-link> -->
            <!-- <router-link
              :to="{ name: 'DealList' }"
              id="DealList"
              :class="{
                'menu-item1 selected': CurrPath == 'DealList',
                'menu-item1': CurrPath != 'DealList',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="draft-icon"></i
                >{{ lmodel?.menuContinueFromDraft }}</span
              >
            </router-link> -->
          </div>

          <div v-show="visibleConfigurationMenu">
            <div class="menu-head">{{ lmodel?.subMenuConfiguration }}</div>
            <router-link
              v-show="this.$store.state.isEnableDeprecatedSite === true"
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              :to="{ name: 'SiteList' }"
              id="SiteList"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'SiteCreate' ||
                  CurrPath == 'SiteEdit' ||
                  CurrPath == 'SiteList',
                'menu-item1':
                  CurrPath != 'SiteCreate' ||
                  CurrPath != 'SiteEdit' ||
                  CurrPath != 'SiteList',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel.newSite1 }}</span
              >
            </router-link>
            <router-link
              v-if="$store.state.cognitoInfo.role != 'User'"
              :to="{ name: 'NewSiteList' }"
              id="NewSiteList"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'NewSiteCreate' ||
                  CurrPath == 'NewSiteEdit' ||
                  CurrPath == 'NewSiteList',
                'menu-item1':
                  CurrPath != 'NewSiteCreate' ||
                  CurrPath != 'NewSiteEdit' ||
                  CurrPath != 'NewSiteList',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel?.menuSites }}</span
              >
            </router-link>

            <router-link
              v-if="
                $store.state.cognitoInfo.role != 'User' &&
                $store.state.cognitoInfo.role != 'Singletenantadmin'
              "
              :to="{ name: 'CompanyList' }"
              id="CompanyList"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'CompanyCreate' ||
                  CurrPath == 'CompanyEdit' ||
                  CurrPath == 'CompanyList',
                'menu-item1':
                  CurrPath != 'CompanyCreate' ||
                  CurrPath != 'CompanyEdit' ||
                  CurrPath != 'CompanyList',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="hotel-icon"></i>{{ lmodel?.menuCompany }}</span
              >
            </router-link>
            <a
              href="https://developer.voyado.com/en/onsite-messaging.html"
              target="_blank"
              id="Ho1me"
              :class="
                $store.state.activeRoute === 'OnsiteDashboard'
                  ? 'menu-item1 selected'
                  : 'menu-item1'
              "
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="overview-icon"></i
                >{{ lmodel?.menuInstallation }}</span
              >
            </a>
          </div>

          <div v-show="visibleInsightMenu">
            <div class="menu-head">{{ lmodel?.subMenuInsightReports }}</div>
            <router-link
              :to="{ name: 'Performance' }"
              id="Performance"
              :class="{
                'menu-item1 selected': CurrPath == 'Performance',
                'menu-item1': CurrPath != 'Performance',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="draft-icon"></i>{{ lmodel?.menuPerformance }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'Ambassadors' }"
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              id="Ambassadors"
              :class="{
                'menu-item1 selected': CurrPath == 'Ambassadors',
                'menu-item1': CurrPath != 'Ambassadors',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="user-plus-icon"></i
                >{{ lmodel?.menuMyAmbassadors }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'Friends' }"
              id="Friends"
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              :class="{
                'menu-item1 selected': CurrPath == 'Friends',
                'menu-item1': CurrPath != 'Friends',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="friend-icon"></i>{{ lmodel?.menuMyFriends }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'Relations' }"
              id="Relations"
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              :class="{
                'menu-item1 selected': CurrPath == 'Relations',
                'menu-item1': CurrPath != 'Relations',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="heart-circle-icon"></i>{{ lmodel?.relations }}</span
              >
            </router-link>
          </div>

          <div v-show="visibleOperationDashboardMenu">
            <div class="menu-head">{{ lmodel?.subMenuOprationWizard }}</div>
            <router-link
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              :to="{ name: 'FailedContact' }"
              id="FailedContact"
              :class="{
                'menu-item1 selected': CurrPath == 'FailedContact',
                'menu-item1': CurrPath != 'FailedContact',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="file-icon"></i>{{ lmodel?.menuFailContact }}</span
              >
            </router-link>
            <router-link
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin'
              "
              :to="{ name: 'Error' }"
              id="Error"
              :class="{
                'menu-item1 selected': CurrPath == 'Error',
                'menu-item1': CurrPath != 'Error',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="error-icon"></i>{{ lmodel?.menuErrorSummary }}</span
              >
            </router-link>
            <router-link
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin' ||
                $store.state.cognitoInfo.role == 'Systemadmin' ||
                $store.state.cognitoInfo.role == 'Partner' ||
                $store.state.cognitoInfo.role == 'Admin' ||
                $store.state.cognitoInfo.role == 'Alltenantadmin'
              "
              :to="{ name: 'calllog' }"
              id="calllog"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'calllog' || CurrPath == 'calllogbykeyid',
                'menu-item1':
                  CurrPath != 'calllog' || CurrPath != 'calllogbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="call-icon"></span>{{ lmodel.callLog }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'sessiondashboard' }"
              id="sessiondashboard"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'sessiondashboard' ||
                  CurrPath == 'sessiondashboardbyid' ||
                  CurrPath == 'sessiondashboardbykeyid',
                'menu-item1':
                  CurrPath != 'sessiondashboard' ||
                  CurrPath != 'sessiondashboardbyid' ||
                  CurrPath != 'sessiondashboardbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="sessions-icon"></span>{{ lmodel.sessions }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'sessionlogdashboard' }"
              id="sessionlogdashboard"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'sessionlogdashboard' ||
                  CurrPath == 'sessionlogdashboardbyid' ||
                  CurrPath == 'sessionlogdashboardbykeyid',
                'menu-item1':
                  CurrPath != 'sessionlogdashboard' ||
                  CurrPath != 'sessionlogdashboardbyid' ||
                  CurrPath != 'sessionlogdashboardbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="sessions-icon"></span
                >{{ lmodel.menuSessionLogs }}</span
              >
            </router-link>
            <router-link
              v-if="$store.state.cognitoInfo.role == 'Superadmin'"
              :to="{ name: 'activeorders' }"
              id="activeorders"
              :class="{
                'menu-item1 selected': CurrPath == 'activeorders',
                'menu-item1': CurrPath != 'activeorders',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="sessions-icon"></span
                >{{ lmodel.activeOrders }}</span
              >
            </router-link>
            <router-link
              :to="{ name: 'errorlogbycompany' }"
              id="errorlogbycompany"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'errorlogbycompany' ||
                  CurrPath == 'errorlogbycompanyid',
                'menu-item1':
                  CurrPath != 'errorlogbycompany' ||
                  CurrPath != 'errorlogbycompanyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="error-log"></span>{{ lmodel.errorLog }}</span
              >
            </router-link>
            <router-link
              v-if="
                $store.state.cognitoInfo.role != 'User' &&
                $store.state.cognitoInfo.role != 'Singletenantadmin'
              "
              :to="{ name: 'ongoingerror' }"
              id="ongoingerror"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'ongoingerror' ||
                  CurrPath == 'ongoingerrorid',
                'menu-item1':
                  CurrPath != 'ongoingerror' ||
                  CurrPath != 'ongoingerrorid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="error-log"></span>{{ lmodel.ongoingErrors }}</span
              >
            </router-link>
            <router-link
              v-if="
                $store.state.cognitoInfo.role == 'Superadmin'
              "
              :to="{ name: 'allongoingerror' }"
              id="allongoingerror"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'allongoingerror' ||
                  CurrPath == 'allongoingerrorid',
                'menu-item1':
                  CurrPath != 'allongoingerror' ||
                  CurrPath != 'allongoingerrorid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><span class="error-log"></span>{{ lmodel.allOngoingErrors }}</span
              >
            </router-link>
          </div>
          <div v-show="visibleNewDealMenu">
            <div class="menu-head">{{ lmodel?.subMenuManageDeals }}</div>
            <router-link
              style="text-decoration: none"
              :to="{ name: 'ModifyDeal' }"
              id="deal-list"
              :class="{
                'menu-item1 selected': DealListTabArray.includes(CurrPath),
                'menu-item1': !DealListTabArray.includes(CurrPath),
              }"
            >
              <!-- <i
                :class="{
                  'list-active selected': DealListTabArray.includes(CurrPath),
                  'list-icon': !DealListTabArray.includes(CurrPath),
                }"
              ></i> -->
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="pen-icon"></i>{{ lmodel.menuManageDealsNew }}</span
              >
            </router-link>
            <router-link
              v-show="this.$store.state.isEnableDeprecatedSite === true"
              style="text-decoration: none"
              :to="{ name: 'ManageDealListNew' }"
              id="manage-deals"
              :class="{
                'menu-item1 selected': ManageDealTabArray.includes(CurrPath),
                'menu-item1': !ManageDealTabArray.includes(CurrPath),
              }"
            >
              <!-- <i
                :class="{
                  'pen-active-icon selected':
                    ManageDealTabArray.includes(CurrPath),
                  'pen-icon': !ManageDealTabArray.includes(CurrPath),
                }"
              ></i> -->
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="pen-icon"></i>{{ lmodel.menuManageDealsOld }}</span
              >
            </router-link>
            <!-- <div v-show="visibleNewDealMenu"> -->
          </div>
          <div v-show="visibleAcceleratorMenu">
            <div class="menu-head">{{ lmodel?.subAccelerator }}</div>
            <router-link
              v-if="this.$store.state.leads.isEcom"
              v-show="
                $store.state.cognitoInfo.role != 'Accessadmin' &&
                $store.state.cognitoInfo.role != 'User'
              "
              :to="{ name: 'acceleratorsite' }"
              id="acceleratorsite"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratorsite' ||
                  CurrPath == 'acceleratoredit',
                'menu-item1':
                  CurrPath != 'acceleratorsite' ||
                  CurrPath != 'acceleratoredit',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i
                >{{ lmodel?.submenuAccelerator }}</span
              >
            </router-link>

            <router-link
              v-if="this.$store.state.leads.isLead"
              :to="{ name: 'leadadslist' }"
              id="leadadslist"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'leadadslist' || CurrPath == 'leadadsedit',
                'menu-item1':
                  CurrPath != 'leadadslist' || CurrPath != 'leadadsedit',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel?.menuLeads }}</span
              >
            </router-link>
            <router-link
              v-if="this.$store.state.leads.isElevate"
              v-show="
                $store.state.cognitoInfo.role != 'Accessadmin' &&
                $store.state.cognitoInfo.role != 'User'
              "
              :to="{ name: 'elevatelist' }"
              id="elevatelist"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'elevatelist' || CurrPath == 'elevateedit',
                'menu-item1':
                  CurrPath != 'elevatelist' || CurrPath != 'elevateedit',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel?.menuVoyadoElevate }}</span
              >
            </router-link>
          </div>

          <div v-show="visibleAcceleratorDashboardMenu">
            <div class="menu-head">{{ lmodel?.menuAccelerator }}</div>
            <router-link
              v-if="this.$store.state.leads.isElevate"
              :to="{ name: 'acceleratordashboardproducts' }"
              id="acceleratordashboardproducts"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardproducts' ||
                  CurrPath == 'acceleratordashboardproductsbyid' ||
                  CurrPath == 'acceleratordashboardproductbykeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardproducts' ||
                  CurrPath != 'acceleratordashboardproductsbyid' ||
                  CurrPath != 'acceleratordashboardproductbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel.productDashboard }}</span
              >
            </router-link>
            <router-link
              v-if="this.$store.state.leads.isEcom"
              :to="{ name: 'acceleratordashboardorders' }"
              id="acceleratordashboardorders"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardorders' ||
                  CurrPath == 'acceleratordashboardordersbyid' ||
                  CurrPath == 'acceleratordashboardorderbykeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardorders' ||
                  CurrPath != 'acceleratordashboardordersbyid' ||
                  CurrPath != 'acceleratordashboardorderbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel.orderDashboard }}</span
              >
            </router-link>
            <router-link
              v-if="this.$store.state.leads.isEcom"
              :to="{ name: 'acceleratordashboardcontacts' }"
              id="acceleratordashboardcontacts"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardcontacts' ||
                  CurrPath == 'acceleratordashboardcontactsbyid' ||
                  CurrPath == 'acceleratordashboardcontactsbykeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardcontacts' ||
                  CurrPath != 'acceleratordashboardcontactsbyid' ||
                  CurrPath != 'acceleratordashboardcontactsbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel.contactDashboard }}</span
              >
            </router-link>
            <router-link
              v-if="this.$store.state.leads.isEcom"
              :to="{ name: 'acceleratordashboardinventories' }"
              id="acceleratordashboardinventories"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardinventories' ||
                  CurrPath == 'acceleratordashboardinventoriesbyid' ||
                  CurrPath == 'acceleratordashboardinventoriesbykeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardinventories' ||
                  CurrPath != 'acceleratordashboardinventoriesbyid' ||
                  CurrPath != 'acceleratordashboardinventoriesbykeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i> {{ lmodel.inventories }}</span
              >
            </router-link>
            <router-link
              v-show="false"
              v-if="this.$store.state.leads.isElevate"
              :to="{ name: 'acceleratordashboardmarkets' }"
              id="acceleratordashboardmarkets"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardmarkets' ||
                  CurrPath == 'acceleratordashboardmarketsbyid' ||
                  CurrPath == 'acceleratordashboardmarketsbyidkeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardmarkets' ||
                  CurrPath != 'acceleratordashboardmarketsbyid' ||
                  CurrPath != 'acceleratordashboardmarketsbyidkeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i> {{ lmodel.markets }}</span
              >
            </router-link>
            <router-link
              v-if="this.$store.state.leads.isEcom"
              :to="{ name: 'acceleratordashboardreceipt' }"
              id="acceleratordashboardreceipt"
              :class="{
                'menu-item1 selected':
                  CurrPath == 'acceleratordashboardreceipt' ||
                  CurrPath == 'acceleratordashboardreceiptbyid' ||
                  CurrPath == 'acceleratordashboardreceiptbyidkeyid',
                'menu-item1':
                  CurrPath != 'acceleratordashboardreceipt' ||
                  CurrPath != 'acceleratordashboardreceiptbyid' ||
                  CurrPath != 'acceleratordashboardreceiptbyidkeyid',
              }"
            >
              <span class="submenu-item" @click="isExpandHide()"
                ><i class="lists-icon"></i>{{ lmodel.receipts }}</span
              >
            </router-link>
          </div>
          <!-- </div> -->
        </div>

        <div class="pin-menu">
          <span>{{ lmodel.pinMenu1 }}</span>
          <form-toggle
            id="pinMenu"
            v-model="pinMenu"
            @change="this.$emit('call')"
          />
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import DataLayerService from "@/services/data-layer.service";
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import Store from "@/store/index";
const baseURL = Store.state.apiURL;

export default {
  components: {
    "model-select": ModelSelect,
  },
  data() {
    return {
      // isDeprecatd: this.$store.state.isEnableDeprecatedSite,
      dropdownShow: false,
      languages: [], // To hold language options
      selectedLanguage: "en",
      url: process.env.VUE_APP_MANAGER_API_URL,
      HomeTabArray: ["OnsiteDashboard"],
      DealTabArray: ["NewDealCreate", "modifydeal", "DealEditNew", "DealList"],
      AcceleratorTabArray: [
        "acceleratordashboardproducts",
        "acceleratordashboardproductsbyid",
        "acceleratordashboardproductbykeyid",
        "acceleratordashboardorders",
        "acceleratordashboardordersbyid",
        "acceleratordashboardorderbykeyid",
        "acceleratordashboardcontacts",
        "acceleratordashboardcontactsbyid",
        "acceleratordashboardcontactsbykeyid",
        "acceleratordashboardinventories",
        "acceleratordashboardinventoriesbyid",
        "acceleratordashboardinventoriesbykeyid",
        "acceleratordashboardmarkets",
        "acceleratordashboardmarketsbyid",
        "acceleratordashboardmarketsbyidkeyid",
        "acceleratordashboardreceipt",
        "acceleratordashboardreceiptbyid",
        "acceleratordashboardreceiptbyidkeyid",
      ],
      OverviewTabArray: ["VoyadoDashboard", "Home"],
      ContentGeneratorTabArray: ["contentgenerator"],
      aiContentTabArray: ["aicontent"],
      aiVideoContentTabArray: ["aivideocontent"],
      // LeadAdsTabArray: ["leadads"],
      DealListTabArray: ["ModifyDeal"],
      isSidebarExpanded: false,
      AccTabArray: [
        "acceleratorsite",
        "acceleratoredit",
        "leadadsedit",
        "leadadslist",
        "elevateedit",
        "elevatelist",
      ],
      ConfigTabArray: [
        "SiteList",
        "SiteCreate",
        "SiteEdit",
        "SiteCopy",
        "CompanyCreate",
        "CompanyList",
        "CompanyEdit",
        "NewSiteList",
      ],
      ManageDealTabArray: [
        "ManageDealListNew",
        "ManageDealList",
        "EditDeal",
        "CopyDeal",
        "DealLogs",
        "DealSearch",
        "ManageDealUpdateById",
        "ManageDealUpdateCreate",
        "copydeal",
        "ModifyDeal",
      ],
      ReportTabArray: ["Performance", "Ambassadors", "Friends", "Relations"],
      ContactTabArray: [
        "contactlist",
        "errorsummary",
        "FailedContact",
        "Error",
        "calllogsite",
        "calllog",
        "calllogbykeyid",
        "sessiondashboard",
        "sessiondashboardbyid",
        "sessiondashboardbykeyid",
        "sessionlogdashboard",
        "sessionlogdashboardbyid",
        "sessionlogdashboardbykeyid",
        "errorlogbycompany",
        "errorlogbycompanyid",
        "ongoingerror",
        "ongoingerrorbyerrorlogid",
        "allongoingerror",
        "allongoingerrorbyerrorlogid",
        "activeorders",
      ],
      UserTabArray: ["UserList"],
      // AcceleratorSitesTabArray: ["acceleratorsite","leadads"],
      AudienceTabArray: ["Audiences", "AudienceCreate", "Translation"],
      items: [
        {
          label: "Account Settings",
        },
        {
          label: "Privacy Policy",
          command: () => {
            window.open("https://voyado.com/legal/privacy-policy/", "_blank");
          },
        },
        {
          label: "Essence",
          command: () => {
            window.open(`${window.location.origin}/essence`, "_blank");
          },
        },
        {
          separator: true,
        },
        {
          label: "Logout",
          icon: "signout-icon",
          hoverIcon: "signout-green-icon",
          command: async () => {
            const accessToken = this.$store.state.accesstoken;
            const refreshToken = this.$store.state.refreshtoken;
            const email = this.$store.state.cognitoInfo.email;

            if (accessToken && refreshToken && email) {
              try {
                const payload = { accessToken, refreshToken, email };
                await DataLayerService.post("/auth/Logout", payload);
                console.log("Logout API call successful");
              } catch (error) {
                console.error("Logout API call failed:", error);
              }
            }

            localStorage.removeItem("headersidebar");
            window.location.href = "/logout";
          },
        },
      ],
      hoveredItem: null,
      isExpanded: false,
      visibleDealMenu: false,
      visibleConfigurationMenu: false,
      visibleInsightMenu: false,
      visibleOperationDashboardMenu: false,
      visibleNewDealMenu: false,
      visibleAcceleratorMenu: false,
      visibleAcceleratorDashboardMenu: false,
      lmodel: {}, // Store language-specific labels here
      pinMenu: false,
      expandedMenu: null,
      notifiedErrorCount: 0,
    };
  },
  props: {
    is_not_expand: {
      type: Boolean,
      required: true,
    },
  },
  //   watch: {
  //   $route(to, from) {
  //     if (to.name !== from.name) {
  //       this.getData();
  //     }
  //   }
  // },
  // watch: {
  //   "$store.state.selectedLanguage": {
  //     handler(newValue, oldValue) {
  //       if (newValue !== oldValue) {
  //         if (this.$route.name != undefined) {
  //           this.getData();
  //         }
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  async created() {
    // this.$nextTick(async () => {
    //   if (this.$route.name != undefined) {
    //     await this.getData();
    //   }
    // });
    this.$store.state.prevCompanyId = this.$store.state.cognitoInfo.companyid;
  },
  async mounted() {
    this.notifiedErrorCount = this.$store.state.notifiedErrorCount;
    const savedLanguages = localStorage.getItem("availableLanguages");
    if (savedLanguages) {
      this.languages = JSON.parse(savedLanguages);
    } else {
      // if (this.$route.name !== undefined) {
      this.fetchLanguages();
      // }
    }

    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      this.selectedLanguage = savedLanguage;
    } else {
      const url = this.$route.fullPath;
      const redirect = this.getParamValue(url, "redirect");
      if (redirect) {
        const decodedRedirect = decodeURIComponent(redirect);
        const language = this.getParamValue(decodedRedirect, "language");
        if (language) {
          const extractedLanguage = this.extractLanguageCode(language);
          this.selectedLanguage = extractedLanguage;
        }
      }
    }
    // setTimeout(async () => {
    // if (this.$route.name !== undefined) {
    if (this.$route.name && this.$route.name !== "Login") {
      await this.getData(false);
      await this.getLeadToggle();
      if (this.$store.state.notifiedErrorCount == -1) {
        this.getErrorLog();
      }
    } else if (this.$store.state.headerSidebar) {
      await this.localdata();
    }
  },
  computed: {
    shouldShowAcceleratorMenu() {
      const userRole = this.$store.state.cognitoInfo?.role;
      const isEcom = this.$store.state.leads.isEcom;
      const isElevate = this.$store.state.leads.isElevate;
      const isLead = this.$store.state.leads.isLead;
      const companyId = this.$store.state.cognitoInfo.companyid;

      // Don't show if company is '_all'
      if (companyId === '_all') {
        return false;
      }

      // For User role: hide if isLead is false
      if (userRole === 'User' && isLead === false) {
        return false;
      }

        if (userRole === 'Accessadmin') {
        return false;
      }

      // Don't show if none of the features are enabled
      if (!isEcom && !isElevate && !isLead) {
        return false;
      }

      // For User role with leadads enabled: show the menu
      if (userRole === 'User' && isLead === true) {
        return true;
      }

      // For other roles: show if at least one feature is enabled
      return isEcom || isElevate || isLead;
    },
    CurrPath() {
      return this.$route.name;
    },
    headerClass() {
      return this.pinMenu
        ? "header white-bg expand"
        : "header white-bg not-expand";
    },
  },
  methods: {
    setupDropdownToggle() {
      this.dropdownShow = !this.dropdownShow;
    },
    dropDownOutside() {
      this.dropdownShow = false;
    },
    async getErrorLog(showLoader = false) {
      if (
        this.$store.state.cognitoInfo.companyid &&
        this.$store.state.cognitoInfo.companyid !== "" &&
        this.$store.state.cognitoInfo.companyid !== undefined
      ) {
        try {
          const payload = {
            companyId: this.$store.state.cognitoInfo.companyid,
          };

          const response = await DataLayerService.post(
            "/Accelerator/GetErrorLogByCompanyId",
            payload,
            showLoader
          );

          if (response) {
            this.notifiedErrorCount = response.notifiedErrorCount;
            this.notifiedErrorCount == -1 ? 0 : this.notifiedErrorCount;
            this.$store.commit(
              "setNotifiedErrorCount",
              this.notifiedErrorCount
            );
          } else {
            console.log("No error Detail Found");
          }
        } catch (error) {
          console.error(`Error fetching details for `, error);
        }
      }
    },
    async getLeadToggle() {
      if (
        this.$store.state.cognitoInfo.companyid &&
        this.$store.state.cognitoInfo.companyid !== "" &&
        this.$store.state.cognitoInfo.companyid !== null &&
        this.$store.state.cognitoInfo.companyid !== undefined
      ) {
        await DataLayerService.getById(
          "/Company/GetCompanyEnables",
          this.$store.state.cognitoInfo.companyid,
          null,
          null,
          false
        ).then((result) => {
          if (result && result.isSuccess == true) {
            this.$store.commit("setLeadsData", result.isLeadAdsEnable);
            this.$store.commit("setEcomData", result.isEComEnable);
            this.$store.commit(
              "setisElevateEnableData",
              result.isElevateEnable
            );
            this.$store.commit(
              "setisShowOnSiteMessages",
              result.isShowOnSiteMessage
            );
            this.$store.commit(
              "setMultiPromotionsEnabled",
              result.isMultiPromotionEnable
            );
            // this.$store.commit(
            //   "setTargetingAndBehaviourEnabled",
            //   result.isTargetingBehaviourEnabled
            // );
            this.$store.commit(
              "setMediaLibraryEnabled",
              result.isEnableMediaComponent
            );
            this.$store.commit(
              "setDeprecatedEnabled",
              result.isEnableDeprecatedSite
            );
            this.$store.commit(
              "setCompanystoreId",
              this.$store.state.cognitoInfo.companyid
            );
          }
        });
      }
    },
    async localdata() {
      const headerSidebar = this.$store.state.headerSidebar;

      if (headerSidebar && Object.keys(headerSidebar).length > 0) {
        this.lmodel = headerSidebar;
      } else {
        console.log("headerSidebar is empty or not set");
      }
    },

    extractLanguageCode(locale) {
      if (locale) {
        const normalizedLocale = locale.trim().toLowerCase();
        const languageCode = normalizedLocale.split(/[-_]/)[0];
        return languageCode;
      }
    },
    getParamValue(url, paramName) {
      if (
        url !== undefined &&
        url !== null &&
        paramName !== undefined &&
        paramName !== null
      ) {
        const regex = new RegExp(`[?&]${paramName}=([^&]*)`);
        const match = url.match(regex);
        return match ? decodeURIComponent(match[1]) : null;
      }
    },
    async fetchLanguages() {
      try {
        const _userInfo = this.$store.state.cognitoInfo;

        if (
          _userInfo &&
          Object.keys(_userInfo).length !== 0 &&
          this.$store.state.menudataInfo &&
          Object.keys(this.$store.state.menudataInfo).length !== 0
        ) {
          const url = `${baseURL}/site/GetManagerLanguages`;
          const accessToken = Store.state.cognitoInfo.token;
          const jwtHeader = {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              CompanyId: Store.state.cognitoInfo.companyid || "",
              crossDomain: true,
              "content-type": "application/x-www-form-urlencoded",
            },
          };

          const response = await axios.get(url, jwtHeader);

          if (response && Array.isArray(response.data)) {
            this.languages = response.data;
            localStorage.setItem(
              "availableLanguages",
              JSON.stringify(this.languages)
            );
          } else {
            console.error("Invalid response format for languages:", response);
          }
        } else {
          console.warn("User or menu data is missing.");
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    },

    async getData(value) {
      // console.log("called", value);

      try {
        let languageCode = localStorage.getItem("selectedLanguage") || "en";
        const response = await DataLayerService.get(
          `/resource/${languageCode}`
        );
        if (response && Object.keys(response).length > 0) {
          const localHeader = {
            welcome1: response.Welcome1,
            dealList1: response.DealList1,
            acceleratordashboard: response.acceleratordashboard,
            overview1: response.Overview1,
            contentGenerator1: response.ContentGenerator1,
            newSite1: response.NewSite1,
            menuManageDeals: response.MenuManageDeals,
            menuManageDealsNew: response.menuManageDealsNew,
            menuManageDealsOld: response.menuManageDealsOld,
            pinMenu1: response.PinMenu1,
            menuDashboard: response.MenuDashboard,
            menuConfiguration: response.MenuConfiguration,
            menuInsightReports: response.MenuInsightReports,
            menuUsers: response.MenuUsers,
            menuTranslation: response.MenuTranslation,
            menuOprationWizard: response.menuOprationWizard,
            menuDealWizard: response.MenuDealWizard,
            menuNewWizardPage: response.MenuNewWizardPage,
            menuContinueFromDraft: response.MenuContinueFromDraft,
            menuSites: response.MenuSites,
            menuAccelerator: response.menuAccelerator,
            submenuAccelerator: response.submenuAccelerator,
            menuLeads: response.menuLeads,
            menuCompany: response.MenuCompany,
            menuInstallation: response.MenuInstallation,
            menuPerformance: response.MenuPerformance,
            menuMyAmbassadors: response.MenuMyAmbassadors,
            menuMyFriends: response.MenuMyFriends,
            relations: response.relations,
            menuFailContact: response.MenuFailContact,
            menuErrorSummary: response.menuErrorSummary,
            accelerator: response.accelerator,
            menuVoyadoElevate: response.menuVoyadoElevate,
            subMenuConfiguration: response.subMenuConfiguration,
            subAccelerator: response.subAccelerator,
            subMenuManageDeals: response.subMenuManageDeals,
            subMenuInsightReports: response.subMenuInsightReports,
            subMenuOprationWizard: response.subMenuOprationWizard,
            productDashboard: response.productDashboard,
            orderDashboard: response.orderDashboard,
            contactDashboard: response.contactDashboard,
            inventories: response.inventories,
            callLog: response.callLog,
            markets: response.markets,
            receipts: response.receipts,
            sessions: response.sessions,
            errorLog: response.errorLog,
            menuSessionLogs: response.menuSessionLogs,
            allOngoingErrors: response.allOngoingErrors,
            ongoingErrors: response.ongoingErrors,
            activeOrders: response.activeOrders,
          };
          // localStorage.setItem("headersidebar", JSON.stringify(localHeader));
          this.$store.commit("setHeaderSidebar", localHeader);

          const updatedLModel = {};
          Object.keys(response).forEach((key) => {
            const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
            updatedLModel[lowerCaseKey] = response[key];
          });
          this.lmodel = updatedLModel;
          if (value == true) {
            window.location.reload();
          }
        } else {
          console.warn("No data returned from the API.");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error(
            "Unauthorized access. Please check authentication:",
            error
          );
          // Optionally redirect to login or display a user-friendly error
        } else {
          console.error("Error fetching data:", error);
        }
      }
    },
    async onLanguageChange(newLanguage) {
      this.selectedLanguage = newLanguage;
      localStorage.setItem("selectedLanguage", newLanguage);
      this.$store.commit("setSelectedLanguage", newLanguage);
      await this.getData(true);
    },
    isExpandHide() {
      this.isExpanded = null;
    },
    toggleSidebar(menu) {
      this.isExpanded = !this.isExpanded;

      if (menu === "deal") {
        this.visibleDealMenu = true;
        this.visibleConfigurationMenu = false;
        this.visibleInsightMenu = false;
        this.visibleOperationDashboardMenu = false;
        this.visibleNewDealMenu = false;
        this.visibleAcceleratorMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
        // }
      } else if (menu === "config") {
        this.visibleConfigurationMenu = true;
        this.visibleDealMenu = false;
        this.visibleInsightMenu = false;
        this.visibleOperationDashboardMenu = false;
        this.visibleNewDealMenu = false;
        this.visibleAcceleratorMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
      } else if (menu === "insight") {
        this.visibleInsightMenu = true;
        this.visibleDealMenu = false;
        this.visibleConfigurationMenu = false;
        this.visibleOperationDashboardMenu = false;
        this.visibleNewDealMenu = false;
        this.visibleAcceleratorMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
      } else if (menu === "operation") {
        this.visibleOperationDashboardMenu = true;
        this.visibleDealMenu = false;
        this.visibleInsightMenu = false;
        this.visibleConfigurationMenu = false;
        this.visibleNewDealMenu = false;
        this.visibleAcceleratorMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
      } else if (menu === "newdeal") {
        this.visibleNewDealMenu = true;
        this.visibleOperationDashboardMenu = false;
        this.visibleDealMenu = false;
        this.visibleInsightMenu = false;
        this.visibleConfigurationMenu = false;
        this.visibleAcceleratorMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
      } else if (menu === "accelerator") {
        this.visibleAcceleratorMenu = true;
        this.visibleNewDealMenu = false;
        this.visibleOperationDashboardMenu = false;
        this.visibleDealMenu = false;
        this.visibleInsightMenu = false;
        this.visibleConfigurationMenu = false;
        this.visibleAcceleratorDashboardMenu = false;
      } else if (menu === "acceleratordashboard") {
        this.visibleAcceleratorDashboardMenu = true;
        this.visibleAcceleratorMenu = false;
        this.visibleNewDealMenu = false;
        this.visibleOperationDashboardMenu = false;
        this.visibleDealMenu = false;
        this.visibleInsightMenu = false;
        this.visibleConfigurationMenu = false;
      }
    },
    emitTogglePinMenu() {
      this.$emit("toggle-pin-menu", this.pinMenu);
    },
    handleClickOutside() {
      if (!this.pinMenu) {
        this.isExpanded = null;
      }
    },
    navigate(routeKey) {
      switch (routeKey) {
        case "OnsiteDashboard":
          this.$router.push({ name: "OnsiteDashboard" });
          break;
        case "dealWizard":
          this.expandedMenu = routeKey;
          break;
        case "configuration":
          this.expandedMenu = routeKey;
          break;
        case "newdeal":
          this.expandedMenu = routeKey;
          break;
        case "managedeallistnew":
          this.$router.push({ name: "managedeallistnew" });
          break;
        case "insightreports":
          this.expandedMenu = routeKey;
          break;
        case "operationdash":
          this.expandedMenu = routeKey;
          break;
        default:
          break;
      }
    },
    async onCompanyChange(item) {
      if (this.$store.state.prevCompanyId != item) {
        this.$store.commit("replaceCompanyId", item);

        await this.getErrorLog(true);
        await DataLayerService.getById("/Company/GetCompanyEnables", item).then(
          (result) => {
            if (result && result.isSuccess == true) {
              this.$store.commit("setLeadsData", result.isLeadAdsEnable);
              this.$store.commit("setEcomData", result.isEComEnable);
              this.$store.commit(
                "setisElevateEnableData",
                result.isElevateEnable
              );
              this.$store.commit(
                "setisShowOnSiteMessages",
                result.isShowOnSiteMessage
              );
              this.$store.commit(
                "setMultiPromotionsEnabled",
                result.isMultiPromotionEnable
              );
              this.$store.commit(
                "setMediaLibraryEnabled",
                result.isEnableMediaComponent
              );
              this.$store.commit(
                "setDeprecatedEnabled",
                result.isEnableDeprecatedSite
              );
              // this.$store.commit(
              //   "setTargetingAndBehaviourEnabled",
              //   result.isTargetingBehaviourEnabled
              // );
              this.$store.commit("setCompanystoreId", item);
              this.$store.commit("setCallLogsSite", "");
              this.$store.commit("setErrorLogsSite", "");
              this.$store.commit("setErrorModuleValue", "");
            }
          }
        );

        var routeName = this.$route.name;
        if (routeName == "SiteEdit" || routeName == "SiteCreate") {
          this.$router.push({ name: "SiteList" });
        } else if (routeName == "DealEditNew" || routeName == "DealCreate") {
          this.$router.push({ name: "DealList" });
        } else if (routeName == "EditDeal") {
          this.$router.push({ name: "ManageDealList" });
        } else if (routeName == "UserEdit" || routeName == "UserCreate") {
          this.$router.push({ name: "UserList" });
        } else if (
          routeName == "acceleratordashboardproductsbyid" ||
          routeName == "acceleratordashboardproductbykeyid"
        ) {
          this.$router.push({ name: "acceleratordashboardproducts" });
        } else if (
          routeName == "acceleratordashboardordersbyid" ||
          routeName == "acceleratordashboardorderbykeyid"
        ) {
          this.$router.push({ name: "acceleratordashboardorders" });
        } else if (
          routeName == "acceleratordashboardcontactsbyid" ||
          routeName == "acceleratordashboardcontactsbykeyid"
        ) {
          this.$router.push({ name: "acceleratordashboardcontacts" });
        } else if (
          routeName == "acceleratordashboardinventoriesbyid" ||
          routeName == "acceleratordashboardinventoriesbykeyid"
        ) {
          this.$router.push({ name: "acceleratordashboardinventories" });
        } else if (
          routeName == "acceleratordashboardreceiptbyid" ||
          routeName == "acceleratordashboardreceiptbyidkeyid"
        ) {
          this.$router.push({ name: "acceleratordashboardreceipt" });
        } else if (routeName == "calllogbykeyid") {
          this.$router.push({ name: "calllog" });
        } else if (
          routeName == "sessiondashboardbyid" ||
          routeName == "sessiondashboardbykeyid"
        ) {
          this.$router.push({ name: "sessiondashboard" });
        } else if (
          routeName == "sessionlogdashboardbyid" ||
          routeName == "sessionlogdashboardbykeyid"
        ) {
          this.$router.push({ name: "sessionlogdashboard" });
        } else if (routeName == "errorlogbycompanyid") {
          this.$router.push({ name: "errorlogbycompany" });
        } else if (routeName == "ongoingerrorbyerrorlogid") {
          this.$router.push({ name: "ongoingerror" });
        } else if (routeName == "allongoingerrorbyerrorlogid") {
          this.$router.push({ name: "allongoingerror" });
        } else if (routeName == "CompanyEdit") {
          this.$router.push({ name: "CompanyList" });
        } else {
          if (routeName == "OnsiteDashboard")
            this.$store.commit("resetDashboardLastSync");
          this.$router.go();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/headerbarnew.scss";
@import "@/assets/css/global.css";

::v-deep(.dashboard-style) {
  .fa {
    color: #4cb87d !important;
  }
}

:deep(.icon) {
  .pi-chevron-down:before {
    content: url("../../assets/images/user-icon.png");
    color: #21211f !important;
  }
}
:deep(.p-dropdown) {
  height: calc(1.5em + 0.75rem + 7px);
  width: 360px;
  line-height: 1.5;
  font-size: 14px;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  color: #777 !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
}
.ui.selection.dropdown {
  min-height: 14px;
  height: calc(1.5em + 0.75rem + 7px);
  width: 360px;
  line-height: 1.5;
  font-size: 14px;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  color: #777 !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
}

:deep(.fa-plus.selected) {
  color: #fff;
}

.submenu-item {
  display: flex;
  align-items: center;
  font-family: "Voyado Text";
  font-weight: 400;
  padding: 10px;
  cursor: pointer;
  font-size: 14.22px;
  color: #21211f;
  transition: background-color 0.3s, color 0.3s;
  gap: 5px;

  &:hover {
    background-color: #f5f5f5;
    color: #791a3f;
    border: 1px;
    border-radius: 20px;
  }

  i {
    margin-right: 5px;
    font-size: 16px;
  }
}

.expand {
  margin-left: 340px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.not-expand {
  margin-left: 90px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
:deep(.p-badge) {
  background: #007bff;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 1rem;
  height: 1rem;
  line-height: 1rem;
}
.notification-badge {
  cursor: pointer;
  margin: 0px 10px;
}
.dropdownBtn {
  padding: 12px 16px;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  display: inline-block;
  background-color: white;
}

.dropdownBtn:hover {
  background-color: #f0f0ef;
}
.dropdown-content {
  display: block;
  position: absolute;
  background-color: white;
  min-width: 139px;
  width: 139px;
  z-index: 1000;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  right: 13px;
  color: black;
}

.dropdownItems {
  text-decoration: none;
  color: black;
  padding: 10px 8px;
  display: flex;
  font-size: 14px;
}
.dropdownItems:hover {
  background-color: #f0f0ef;
  color: #2d6e6d;
  cursor: pointer;
}
.dropdown-content .dropDownSeparator {
  height: 1px;
  background-color: #e5e5e5;
  margin: 8px 0;
}
:deep(.signout-icon) {
  position: relative;
  top: 1.5px;
}
:deep(.signout-green-icon) {
  position: relative;
  top: 1.5px;
}
</style>
